module.exports = "/assets/site/images/icon-arrow-right.png?497c7b61c64de8ea9cf65723ea69ed77";